import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "moduleId"]

  open(event) {
    if (!this.hasDialogTarget) {
      return
    }

    const trigger = event?.currentTarget
    const moduleId = trigger?.dataset?.moduleId

    const form = this.dialogTarget.querySelector("form")
    if (form) {
      form.reset()
    }

    if (this.hasModuleIdTarget && moduleId) {
      this.moduleIdTarget.value = moduleId
    }

    this.showDialog()
  }

  close() {
    if (!this.hasDialogTarget) {
      return
    }

    if (this.dialogTarget.close) {
      this.dialogTarget.close()
    } else {
      this.dialogTarget.removeAttribute("open")
    }
  }

  showDialog() {
    if (this.dialogTarget.showModal) {
      this.dialogTarget.showModal()
    } else {
      this.dialogTarget.setAttribute("open", "open")
    }
  }
}
